<template>
	<div class="integration-bank-account">
		<integration-accounts
			:name="'Bank Accounts'"
			:accounts="accounts"
			:empty-message="`No Bank Accounts Added`"
			:editable="false"
			@remove="showRemoveConfirmation">
			<template slot-scope="slotProps">
				<div class="d-flex align-items-center">
					<div class="integration-account__icon mr-3">
						<!-- <img class="img-responsive" :src="`/images/logo-${slotProps.account.name}.png`" :alt="slotProps.account.label"> -->
						<img class="img-responsive" :src="`https://cdn.ostock.id/img/banks/bank-${getIcon(slotProps)}.png`" :alt="slotProps.account.label">
					</div>
					<div>
						<b>{{ slotProps.account.label }}</b> - {{ slotProps.account.account_name }} - {{ slotProps.account.account_number }}
					</div>
				</div>
			</template>
		</integration-accounts>

		<!-- Remove Confirmation -->
		<modal
			class="delete-modal"
			size="medium"
			@close="isRemoveConfirmVisible = false"
			v-if="isRemoveConfirmVisible">
			<template v-if="bankAccountsTotal > 1">
				<template slot="header">
					<h3>Remove Confirmation</h3>
				</template>
				<template slot="body">
					<p>Are you sure want to remove bank account</p>
					<p class="text-bold">{{ selectedBankAccountConfirmationText }} ?</p>
				</template>
				<template slot="footer">
					<!-- Cancel -->
					<button
						type="button"
						class="btn btn-light"
						@click="isRemoveConfirmVisible = false">
						No
					</button>
					<!-- Submit -->
					<button
						class="btn btn-success"
						:class="{ 'is-loading': isDeleting }"
						@click="remove">
						<span>{{ $t('Yes') }}</span>
					</button>
				</template>
			</template>
			<template v-else>
				<template slot="header">
					<h3>Can't Remove Bank Account</h3>
				</template>
				<template slot="body">
					<p>There must be at least 1 registered bank account.</p>
				</template>
			</template>
		</modal>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import IntegrationAccounts from './IntegrationAccounts.vue';
import Modal from '@/components/Modal.vue';
import { banks } from '@/lib/statics';

export default {
	name: 'bankAccounts',
	props: {
		accounts: {
			type: Array,
		},
	},
	components: {
		IntegrationAccounts,
		Modal,
	},
	data() {
		return {
			isDeleting: false,
			isRemoveConfirmVisible: false,
			selectedIndex: false,
			selectedBankAccount: false,
		};
	},
	methods: {
		...mapActions({
			removeBankAccount: 'removeBankAccount',
		}),
		remove() {
			this.isDeleting = true;
			const cb = () => {
				this.isDeleting = false;
				this.selectedBankAccount = false;
				this.isRemoveConfirmVisible = false;
			};
			const errorCb = () => {
				this.isDeleting = false;
				this.selectedBankAccount = false;
				this.isRemoveConfirmVisible = false;
			};
			this.removeBankAccount({ index: this.selectedIndex, cb, errorCb });
		},
		showRemoveConfirmation(index) {
			this.isRemoveConfirmVisible = true;
			this.selectedIndex = index;
			this.selectedBankAccount = this.bankAccounts[index];
		},
		getIcon(props) {
			const bank = banks.find(curr => curr.name === props.account.name);
			return bank?.icon ? props.account.name : 'default';
		},
	},
	computed: {
		...mapGetters({
			bankAccounts: 'bankAccounts',
		}),
		selectedBankAccountConfirmationText() {
			let text = '';
			if (this.selectedBankAccount) {
				text = `${this.selectedBankAccount.label} - ${this.selectedBankAccount.account_name} - ${this.selectedBankAccount.account_number}`;
			}
			return text;
		},
		bankAccountsTotal() {
			return this.bankAccounts?.length ?? 0;
		},
	},
};
</script>
<style scoped>
.integration-account__icon {
	width: 75px;
}
</style>
